import { useAllFreightTypes } from '@repo/sdk'
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui/components'
import { Control } from 'react-hook-form'

interface Props {
  control: Control<{ packaging_type_id: number }>
}

export const PackagingTypeSelect = ({ control }: Props) => {
  'use memo'

  const { data: freightTypes } = useAllFreightTypes()

  return (
    <FormField
      control={control}
      name={'packaging_type_id'}
      render={({ field }) => (
        <FormItem className={'w-full'}>
          <FormControl>
            <Select onValueChange={field.onChange} value={field.value?.toString()}>
              <SelectTrigger
                className={
                  'w-full rounded-l-none border-none ring-transparent ring-offset-transparent'
                }
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {freightTypes?.map((type, index) => (
                  <SelectItem key={index} value={type.id.toString()}>
                    {type.title}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
